// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-swiper {
  pointer-events: none;
  --slide-margin-positive: 22px;
  --slide-margin-negative: -22px;
  --swiper-height: 320px;
}
motes-swiper .loading {
  color: white;
  text-align: center;
  margin-top: 20%;
}
motes-swiper .disable-pointer-events .slider {
  pointer-events: none;
}
motes-swiper .vertical-slider .slide {
  pointer-events: none;
}
motes-swiper .slide.horizontal {
  align-items: flex-end;
}
motes-swiper .horizontal-slider .slide {
  pointer-events: auto;
}
motes-swiper .motes-swiper-container {
  position: relative;
  width: 100%;
  z-index: 2;
  pointer-events: none;
  margin-bottom: var(--safe-area-bottom);
}
motes-swiper .vertical-slider {
  pointer-events: none;
  position: relative;
  bottom: 0;
  height: auto;
  width: 100%;
  display: block;
}
motes-swiper .empty-slide {
  touch-action: none;
}
motes-swiper .mote-slide {
  width: 100%;
  vertical-align: middle;
  overflow: hidden;
  padding: 0 5px;
  box-sizing: border-box;
  transform: scale(0.9);
  pointer-events: auto;
}
motes-swiper .active-slide > .mote-slide {
  transform: scale(1) !important;
  transition: 350ms;
}
motes-swiper .prev-slides > .mote-slide {
  transform: scale(0.9) translateX(var(--slide-margin-negative));
  transition-duration: 340ms;
}
motes-swiper .next-slides > .mote-slide {
  transform: scale(0.9) translateX(var(--slide-margin-positive));
  transition-duration: 340ms;
}
motes-swiper .motes-swiper {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
motes-swiper .experience-map-details {
  display: flex;
  justify-content: space-between;
}
motes-swiper .experience-map-details > * {
  white-space: nowrap;
}
motes-swiper .experience-map-details > *:first-child {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  width: -moz-fit-content;
  width: fit-content;
}
motes-swiper .experience-map-details > *:last-child {
  text-align: right;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/motes-swiper/motes-swiper.component.scss"],"names":[],"mappings":"AAAA;EAEI,oBAAA;EAEA,6BAAA;EACA,8BAAA;EAEA,sBAAA;AAFJ;AAII;EACI,YAAA;EACA,kBAAA;EACA,eAAA;AAFR;AAKI;EACI,oBAAA;AAHR;AAMI;EAEI,oBAAA;AALR;AAQI;EACI,qBAAA;AANR;AASI;EACI,oBAAA;AAPR;AAUI;EAGI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,sCAAA;AAVR;AAaI;EACI,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAXR;AAcI;EACI,kBAAA;AAZR;AAeI;EACI,WAAA;EAEA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;AAdR;AAiBI;EACI,8BAAA;EACA,iBAAA;AAfR;AAmBI;EACI,8DAAA;EACA,0BAAA;AAjBR;AAqBI;EACI,8DAAA;EACA,0BAAA;AAnBR;AAuBI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AArBR;AAwBI;EACI,aAAA;EACA,8BAAA;AAtBR;AAwBQ;EACI,mBAAA;AAtBZ;AAwBY;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;AAtBhB;AAyBY;EACI,iBAAA;EACA,iBAAA;AAvBhB","sourcesContent":["motes-swiper {\n\n    pointer-events: none;\n    // OBS This must be in pixels - pct will make the swiper perform significantly worse\n    --slide-margin-positive: 22px;\n    --slide-margin-negative: -22px;\n    // This will be overwritten by js controller\n    --swiper-height: 320px;\n\n    .loading {\n        color: white;\n        text-align: center;\n        margin-top: 20%;\n    }\n\n    .disable-pointer-events .slider {\n        pointer-events: none;\n    }\n\n    .vertical-slider .slide {\n        // Ensure that touch events are not handled in outer slide\n        pointer-events: none;\n    }\n\n    .slide.horizontal {\n        align-items: flex-end;\n    }\n\n    .horizontal-slider .slide {\n        pointer-events: auto;\n    }\n\n    .motes-swiper-container {\n        // position: fixed;\n        // bottom: 0px;\n        position: relative;\n        width: 100%;\n        z-index: 2;\n        pointer-events: none;\n        margin-bottom: var(--safe-area-bottom);\n    }\n\n    .vertical-slider {\n        pointer-events: none;\n        position: relative;\n        bottom: 0;\n        height: auto;\n        width: 100%;\n        display: block;\n    }\n\n    .empty-slide {\n        touch-action: none;\n    }\n\n    .mote-slide {\n        width: 100%;\n        // height: 100%;\n        vertical-align: middle;\n        overflow: hidden;\n        padding: 0 5px;\n        box-sizing: border-box;\n        transform: scale(0.9);\n        pointer-events: auto;\n    }\n\n    .active-slide>.mote-slide {\n        transform: scale(1) !important;\n        transition: 350ms;\n        // transition-delay: 20ms;\n    }\n\n    .prev-slides > .mote-slide {\n        transform: scale(0.9) translateX(var(--slide-margin-negative));\n        transition-duration: 340ms;\n        // transition-delay: 50ms;\n    }\n\n    .next-slides > .mote-slide {\n        transform: scale(0.9) translateX(var(--slide-margin-positive));\n        transition-duration: 340ms;\n        // transition-delay: 50ms;\n    }\n\n    .motes-swiper {\n        position: absolute;\n        bottom: 0px;\n        width: 100%;\n    }\n\n    .experience-map-details {\n        display: flex;\n        justify-content: space-between;\n\n        > * {\n            white-space: nowrap;\n            \n            &:first-child {\n                text-align: left;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                width: fit-content;\n            }\n    \n            &:last-child {\n                text-align: right;\n                margin-left: 10px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
